import { CanvasView } from "./components/CanvasView.js";
import { Toolbar } from "./components/Toolbar.js";
import { SaveBar, StartScreen } from "./components/SaveBar.js";

export function App(): React.ReactElement {
  return (
    <div style={appStyle}>
      <Toolbar />
      <div style={canvasContainerStyle}>
        <CanvasView />
      </div>
      <SaveBar />
      <StartScreen />
    </div>
  );
}

const appStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  width: "100vw",
  overflow: "hidden",
  background: "#1a1a22",
};

const canvasContainerStyle: React.CSSProperties = {
  flex: 1,
  position: "relative",
  overflow: "hidden",
};